import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, Media, SkeletonLine, TextLabel } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { BestOfferButton } from "./BestOfferButton";
export const CreateCollectionOfferFlowHeaderActions = t0 => {
  const $ = _c(10);
  const {
    className
  } = t0;
  const t = useTranslations("wallet.CreateCollectionOfferFlowHeaderActions");
  let t1;
  if ($[0] !== className) {
    t1 = classNames("gap-3 md:mr-10 xl:mr-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("setPriceTo");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Media greaterThanOrEqual="md"><TextLabel className="whitespace-nowrap" size="2xs">{t2}</TextLabel></Media>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BestOfferButton className="w-full" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t3) {
    t5 = <FlexCenter className={t1}>{t3}{t4}</FlexCenter>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export const CreateCollectionOfferFlowHeaderActionsSkeleton = t0 => {
  const $ = _c(10);
  const {
    className
  } = t0;
  const t = useTranslations("wallet.CreateCollectionOfferFlowHeaderActions");
  let t1;
  if ($[0] !== className) {
    t1 = classNames("gap-3 md:mr-10 xl:mr-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("setPriceTo");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Media greaterThanOrEqual="md"><TextLabel className="whitespace-nowrap" size="2xs">{t2}</TextLabel></Media>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SkeletonLine className="h-8 w-full md:w-[68px]" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t3) {
    t5 = <FlexCenter className={t1}>{t3}{t4}</FlexCenter>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};